<template>
  <div v-if="token">
    <head-con :fourWeeksAvg="fourWeeksAvg" @weekEvt="update" :status="listen" />
    <div class="main">
      <nav-con />
      <div class="view">
        <router-view :week="week2" @addSuccess='addSuccess' @fourWeeksAvgEvt="getFourWeeksAvg" />
      </div>
    </div>
  </div>
</template>

<script>
import headCon from '@/components/nav/headcon'
import navCon from '@/components/nav/navcon'
export default {
  name: 'index',
  data () {
    return {
      week2: null,
      fourWeeksAvg: null,
      token: window.sessionStorage.getItem("token"),
      listen: 0 // 这个值变化时，需要调提示语接口
    }
  },
  components: {
    headCon,
    navCon
  },
  created(){
    if (!this.token) {
      this.$router.replace('/login')
      return
    }
  },
  methods: {
    update (e) {
      // console.log('here')
      if (e) {
        this.week2 = e
      }

    },
    addSuccess(){
      this.listen ++
    },
    getFourWeeksAvg (e) {
      //console.log('eee')
      // console.log(e)
      this.fourWeeksAvg = e
    }
  }
}
</script>

<style lang="scss">
.main{
  width: 100%;
  padding-top: 182px;
  position: relative;
  /*min-width: 1350px; */
  background: var(--background-color);
  min-height: 100vh;
  .view{
    overflow: hidden;
    width: 100%;
    box-sizing: border-box;
    padding-left: 160px;
    padding-right: 30px;
    /*min-width: 1000px; */
  }
}
</style>



// WEBPACK FOOTER //
// src/components/index.vue